if(document.querySelector(".hulk__wishlist-wrap")){
      document.body.addEventListener("click",(e) => {
        const btn = document.querySelectorAll("[data-addmywishlistprotocart],[data-hulkmoveallitmes] a,.popup-product-offer [data-addprotocart]");
        btn.forEach(addBtn =>{
          if(e.target == addBtn){
        setTimeout(function(){
          var newCart = new CartDrawer();
              newCart.refresh();
        },1000);
            setTimeout(function(){
            document.querySelector('#cart-drawer-toggle').click();
        },1500);
              
          }
        });
      });
    }
// document.querySelector('.wishlist-btn').addEventListener('touchend', function(event) {
//     event.preventDefault();
//     // Add your custom logic here
// });
